function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "change-password-error",
  transform: "translate(-544.000000, -236.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card02",
  transform: "translate(520.000000, 212.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(24.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FEE8EA",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "lock",
  transform: "translate(17.000000, 13.000000)",
  fill: "#F8202D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5833203,7.76899038 L13.3333203,7.76899038 L13.3333203,6.04253459 C13.3333203,2.7106493 10.7165625,0 7.5,0 C4.2834375,0 1.66667969,2.7106493 1.66667969,6.04253459 L1.66667969,7.76899038 L0.416679687,7.76899038 C0.186367187,7.76899038 0,7.9620417 0,8.20061445 L0,18.9908924 C0,19.9430388 0.747460937,20.7173077 1.66667969,20.7173077 L13.3333594,20.7173077 C14.2525391,20.7173077 15,19.9430388 15,18.9908519 L15,8.20061445 C15,7.9620417 14.8136328,7.76899038 14.5833203,7.76899038 Z M8.74757812,16.785187 C8.76058594,16.9069821 8.72277344,17.0292223 8.64382812,17.1207102 C8.56488281,17.2121577 8.45175781,17.2644366 8.33335937,17.2644366 L6.66667969,17.2644366 C6.54828125,17.2644366 6.43515625,17.2121577 6.35621094,17.1207102 C6.27726562,17.0292628 6.23941406,16.9070225 6.25246094,16.785187 L6.5153125,14.3367411 C6.08847656,14.0151373 5.83335937,13.5063898 5.83335937,12.9483173 C5.83335937,11.9961709 6.58082031,11.2218615 7.50003906,11.2218615 C8.41925781,11.2218615 9.16671875,11.9961304 9.16671875,12.9483173 C9.16671875,13.5063898 8.91160156,14.0151373 8.48476562,14.3367411 L8.74757812,16.785187 Z M10.8333203,7.76899038 L4.16667969,7.76899038 L4.16667969,6.04253459 C4.16667969,4.13864638 5.66203125,2.58966346 7.5,2.58966346 C9.33796875,2.58966346 10.8333203,4.13864638 10.8333203,6.04253459 L10.8333203,7.76899038 L10.8333203,7.76899038 Z",
  id: "Shape"
}))))));

var SvgChangePasswordError = function SvgChangePasswordError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangePasswordError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change-password-error.493f4472.svg";
export { ForwardRef as ReactComponent };